<template>
    <div class="new_tdk_box_view">
        <el-tabs v-model="editableTabsValue" type="border-card"
        >
            {{seacherTdk}}
            <el-tab-pane
                :key="item.media"
                v-for="(item, index) in setAccountData"
                :label="index"
                :name="index"
                class="tab_box"
            >
                <span slot="label">
                    <img :src="item.icon" alt="" class="tdk_top_icon">
                    <template v-if="item.inputBeyond">
                        <span class="tdk_top_name" style="color:red">{{item.name}}</span>
                         <el-popover
                            placement="top-start"
                            width="500"
                            trigger="hover"
                        >
                           <div v-html="tips(item)" class="inputTipsBox">
                           </div>
                            <i class="el-icon-warning" slot="reference" style="color:red;margin-left:5px;"></i>
                        </el-popover>
                    </template>
                    <template v-else>
                        <span class="tdk_top_name">{{item.name}}</span>
                    </template>
                </span>
                    <div>
                        <el-form class="share_video_tdk_form">
                            <el-form-item
                                prop="title"
                                class="share_video_tdk_item"
                                v-if="item.rules&&item.rules.title"
                            >
                                <div class="share_video_tdk_label">
                                    <p>标题/Title
                                        <span class="share_video_tdk_tips" v-if="item.rules.title&&item.rules.title.limit">
                                            (请输入少于{{item.rules.title.limit}}字符，标题可采用“关键词+视频内容主题+品牌+型号”的方式编写)
                                        </span>
                                        <span class="share_video_tdk_tips" v-else>
                                            (标题可采用“关键词+视频内容主题+品牌+型号”的方式编写)
                                        </span>
                                    </p>
                                </div>
                                <div class="share_video_input">
                                    <el-input placeholder="请输入" v-model="item.tdklist.title" v-if="item.tdklist" @input='inputData'>
                                    </el-input>
                                </div>
                            </el-form-item>
                            <el-form-item
                                class="share_video_tdk_item"
                                v-if="item.rules&&item.rules.keywords"
                            >
                                <div class="share_video_tdk_label">
                                    <p>关键词/Keyword
                                        <span class="share_video_tdk_tips" v-if="item.rules.keywords&&item.rules.keywords.limit">
                                            (请输入少于{{item.rules.keywords.limit}}字符，关键词请用英文逗号','隔开)
                                        </span>
                                        <span class="share_video_tdk_tips" v-else>(关键词请用英文逗号','隔开)</span>
                                    </p>
                                </div>
                                <div class="share_video_input">
                                    <el-input type="textarea" placeholder="请输入" v-if="item.tdklist" v-model="item.tdklist.keywords" :autosize="{minRows:3,maxRows:6}" class="keyword_textarea" @input='inputData'></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item
                                class="share_video_tdk_item"
                                v-if="item.rules&&item.rules.desc"
                            >
                                <div class="share_video_tdk_label">
                                    <p>描述/Description
                                        <span class="share_video_tdk_tips" v-if="item.rules.description&&item.rules.description.limit">
                                            (请输入少于{{item.rules.description.limit}}字符，描述可以包含视频内容的概述和匹配视频内容的关键词)
                                        </span>
                                        <span class="share_video_tdk_tips" v-else>
                                            (描述可以包含视频内容的概述和匹配视频内容的关键词)
                                        </span>
                                    </p>
                                </div>
                                <div class="share_video_input">
                                    <el-input type="textarea" placeholder="请输入" v-if="item.tdklist" v-model="item.tdklist.desc" class="keyword_textarea desc_textarea" @input='inputData'></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item
                                class="share_video_tdk_item"
                                v-if="item.name=='Pinterest'"
                            >
                                <el-switch
                                    v-model="websiteBtn"
                                    active-text="加入官网URL"
                                >
                                </el-switch>
                                <div class="share_video_input" v-if="websiteBtn">
                                    <el-input placeholder="请输入" v-model="item.PinterestUrl"  @input='inputData'>
                                    </el-input>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template> 
<script>
import { defineComponent,ref,reactive,watch,getCurrentInstance,computed } from '@vue/composition-api'
// import { defineComponent,ref,reactive,watch,getCurrentInstance,computed } from 'vue'
import {shareDialogStore} from './shareDialogStore.js';
export default defineComponent({
    props: ['tdk','accounts'],
    setup(props,context) {
        const editableTabsValue = ref(0);
        const websiteBtn = ref(false);
        const internalInstance = getCurrentInstance();
        const seacherTdk = computed(()=>{
            setAccountData.forEach(a=>{
                if(shareDialogStore.state.title!=''){
                    a.tdklist.title = shareDialogStore.state.title;
                }
                if(shareDialogStore.state.desc!=''){
                    a.tdklist.desc = shareDialogStore.state.desc;
                }
                if(shareDialogStore.state.keys!=''){
                    a.tdklist.keywords = shareDialogStore.state.keys;
                }
            })
        })
        var tdkList = ref([]);
        var accounts = ref(props.accounts);
        var setAccountData = reactive([]);
        var setAccountDataFn = (()=>{
            setAccountData= accounts.value.reduce((arr,ac) => {
                if (
                    (ac.account.length && ac.isChecked)
                    || (ac.jujiao_account.length && ac.jujiao_isChecked && ac.jujiao_isShow)
                ) {
                    if(ac.name=='Pinterest'){
                        ac.PinterestUrl = '';
                    }
                    minimum('title',ac);
                    minimum('desc',ac)
                    ac.inputBeyond = false;
                    ac.tdklist= Object.assign({},tdkList.value[0]);
                    arr.push(ac);
                }
                return arr;
            },[])
            inputData();
        })
        function minimum(type,item){
            if(type == 'title'){
                if(!item.rules.title){
                    item.rules.title = {
                        minimum: -1
                    }
                }else{
                    switch (item.name){
                        case 'Tiktok':
                            item.rules.title.minimum = 25;
                            return;
                        case 'YouTube':
                            item.rules.title.minimum = 20;
                            return;
                        case 'Facebook':
                            item.rules.title.minimum = 20;
                            return;
                        case 'Twitter':
                            item.rules.title.minimum = 71;
                            return;
                        case 'LinkedIn':
                            item.rules.title.minimum = 50;
                            return;
                        case 'Instagram':
                            item.rules.title.minimum = 20;
                            return;
                        case 'Reddit':
                            item.rules.title.minimum = 100;
                            return;
                        case 'Pinterest':
                            item.rules.title.minimum = 20;
                            return;
                        case 'Vimeo':
                            item.rules.title.minimum = 20;
                            return;
                        case 'Tumblr':
                            item.rules.title.minimum = 100;
                            return;
                        case 'VK':
                            item.rules.title.minimum = 50;
                            return;
                        case 'Veoh':
                            item.rules.title.minimum = 50;
                            return;
                    }
                }
                
            }else if(type=='desc'){
                if(!item.rules.desc){
                    item.rules.desc = {
                        minimum: -1
                    }
                }else{
                    switch (item.name){
                        case 'Instagram':
                            item.rules.desc.minimum = 125;
                            return;
                        case 'Pinterest':
                            item.rules.desc.minimum = 190;
                            return;
                        case 'Facebook':
                            item.rules.desc.minimum = 300;
                            return;
                        case 'Vimeo':
                            item.rules.desc.minimum = 500;
                            return;
                        case 'Tumblr':
                            item.rules.desc.minimum = 100;
                            return;
                        case 'VK':
                            item.rules.desc.minimum = 300;
                            return;
                        case 'Veoh':
                            item.rules.desc.minimum = 190;
                            return;
                    }
                }
            }
        }
        function tips(item){
            var html = ''
            switch (item.name){
                    case 'Tiktok':
                        html = `
                                <p>1. 标题长度在 25 — 80字符为佳；</p>
                                <p>2. 标题建议加入至少三个标签；</p>
                                <p>3. 将视频转换成9:16（竖屏）；</p>
                            `
                        return html;
                    case 'YouTube':
                        html = `
                                <p>1. 标题长度在 20 – 60 字符为佳（不大于 100 字符）；</p>
                                <p>2. 建议至少添加20个关键词；</p>
                                <p>3. 描述长度建议大于 300 字符；</p>
                            `
                        return html;
                    case 'Facebook':
                        html = `
                                <p>1. 标题长度在 20 – 60 字符为佳；</p>
                                <p>2. 描述长度建议大于 300 字符；</p>
                                <p>3. 标题加入至少两个标签；</p>
                            `
                        return html;
                    case 'Twitter':
                        html = `
                                <p>1. 标题长度在 71 – 100 字符为佳；</p>
                                <p>2. 标题加入至少一个标签；</p>
                            `
                        return html;
                    case 'LinkedIn':
                        html = `
                                <p>1. 标题长度在 50 – 100 字符为佳；</p>
                            `
                        return html;
                    case 'Instagram':
                        html = `
                                <p>1. 标题长度在 20 – 60 字符为佳；</p>
                                <p>2. 描述长度建议在 125 — 150 字符为佳；</p>
                                <p>3. 描述加入至少三个标签；</p>
                            `
                        return html;
                    case 'Reddit':
                        html = `
                                <p>1. 标题长度在 100 – 150 字符为佳；</p>
                            `
                        return html;
                    case 'Pinterest':
                        html = `
                                <p>1. 标题长度在 20 – 60 字符为佳；</p>
                                <p>2. 描述长度建议在 190 — 210 字符为佳；</p>
                                <p>3. 描述加入至少两个标签；</p>
                                <p>4. 建议附上官网 URL 链接；</p>
                            `
                        return html;
                    case 'Vimeo':
                        html = `
                                <p>1. 标题长度在 20 – 60 字符为佳（不大于 128 字符）；</p>
                                <p>2. 描述长度建议在 500 — 2200 字符为佳；</p>
                            `
                        return html;
                    case 'Tumblr':
                        html = `
                                <p>1. 标题长度在 100 – 150 字符为佳；</p>
                                <p>2. 描述长度建议大于 300 字符；</p>
                            `
                        return html;
                    case 'VK':
                        html = `
                                <p>1. 标题长度在 50 – 100 字符为佳（不大于 124 字符）；</p>
                                <p>2. 描述长度建议大于 300 字符；</p>
                            `
                        return html;
                    case 'Veoh':
                        html = `
                                <p>1. 标题长度在 50 – 100 字符为佳；</p>
                                <p>2. 关键词建议至少3个；</p>
                                <p>3. 描述长度建议在 190 — 210 字符为佳；</p>
                            `
                        return html;
                }
        }
        function inputData(){
         
            try {
                console.log('internalInstance',internalInstance);
                 console.log('proxy',internalInstance.proxy);
                internalInstance.proxy.$forceUpdate();
            }catch(err){
                console.log('err', err)
            }
            console.log(setAccountData,'setAccountDatasetAccountData')
            setAccountData.forEach((b)=>{
                if
                (
                    (
                        (
                            b.rules.title&&
                            b.rules.title.limit!=0&&
                            b.tdklist.title&&
                            b.tdklist.title!=''&&
                            (b.tdklist.title.length>b.rules.title.limit)
                        )
                        ||
                        (
                            b.rules.title&&
                            b.tdklist.title&&
                            (b.rules.title.minimum>b.tdklist.title.length)
                        )
                    )
                    ||
                    (
                        b.rules.keywords&&
                        b.rules.keywords.limit!=0&&
                        b.tdklist.keywords&&
                        b.tdklist.keywords!=''&&
                        (b.tdklist.keywords.length>b.rules.keywords.limit)
                    )
                    ||
                    (
                        (
                            b.rules.desc&&
                            b.rules.desc.limit!=0&&
                            b.tdklist.desc&&
                            b.tdklist.desc!=''&&
                            (b.tdklist.desc.length>b.rules.desc.limit)
                        )
                        ||
                        (
                            b.rules.desc&&
                            b.tdklist.desc&&
                            (b.rules.desc.minimum>b.tdklist.desc.length)
                        )
                    )
                )
                {
                        b.inputBeyond=true;
                }else{
                        b.inputBeyond=false;
                }
            })
            let list = setAccountData.reduce((a,b)=>{
                let data = {
                    media:b.media,
                    title:b.tdklist.title?b.tdklist.title:'',
                    keywords:b.tdklist.keywords?b.tdklist.keywords:'',
                    desc:b.tdklist.desc?b.tdklist.desc:''
                }
                if(b.name=='Pinterest'&&b.PinterestUrl!=''){
                    data.url = b.PinterestUrl
                }
                a.push(data)
                return a;
            },[])
            context.emit('setAccountData',list)
        }
        watch(()=>{
            return props.tdk
            },(newValue)=>{
            tdkList.value = JSON.parse(JSON.stringify(newValue));
            setAccountDataFn();
        },{
            immediate:true
        })
        return{
            tdkList,
            editableTabsValue,
            setAccountData,
            websiteBtn,
            inputData,
            seacherTdk,
            tips
        }
    }
})
</script>
<style scoped>
    .new_tdk_box_view{
        width: 710px;
    }
    .tdk_top_icon{
        width: 18px;
        height:18px;
        vertical-align: middle;
        margin-right:4px;
    }
    .tdk_top_name{
        font-size: 12px;
    }
    .tab_box{
        height:100% !important;
    }
    .share_video_tdk_form{
        height: 570px;
        overflow-y:auto ;
    }
    .inputTipsBox{
        padding:3px 5px;
    }
</style>
